// extracted by mini-css-extract-plugin
export default {"wrapper-frame":"DrillDownExample_wrapper-frame__Nb9ik","svg":"DrillDownExample_svg__RnCs+"};